<template>
  <chart-component>
    <!-- Title -->
    <template #title>
      {{ title }}
    </template>
    <!-- /Title -->
    <template #switcher>
      <!-- Timeline Period Switcher -->
      <timeline-period-switcher
        class="switcher"
        @change="switchChartPeriod($event)"
      />
      <!-- /Timeline Period Switcher -->
    </template>
    <!-- Chart -->
    <template #chart>
      <revenue-over-time-chart
        hide-title
        :height="height"
        :period="period"
        :chart-animations="chartAnimations"
        :shared-idea="sharedIdea"
      />
    </template>
    <!-- /Chart -->
    <!-- Right side -->
    <template v-if="!hideRightSide" #right-side>
      <chart-component-right-side>
        <total-amount
          class="mb-3"
          :amount="totalAmount"
          :text="$t('charts.totalRevenueStreams')"
        />
        <div>
          <template v-for="(year, index) in byYearAmount">
            <year-info
              :key="index"
              class="mb-3"
              :avatar-text="`Y${index + 1}`"
              :money="year"
              :text="getTotalExpensesEndOfYearDateString(index)"
            />
          </template>
        </div>
      </chart-component-right-side>
    </template>
    <!-- /Right side -->

    <!-- Bottom -->
    <template #bottom>
      <slot name="bottom" />
    </template>
    <!-- /Bottom -->
  </chart-component>
</template>

<script>
import ChartComponent from '@/views/Home/StoryMode/FinancialPlan/Components/ChartComponent'
import ChartComponentRightSide from '@/views/Home/StoryMode/FinancialPlan/Components/ChartComponentRightSide'
import MixinCalculations from '@/mixins/calculations'
import RevenueOverTimeChart from '@/views/Home/StoryMode/Forecast/RevenueStreams/Charts/RevenueOverTimeChart'
import TimelinePeriodSwitcher from '@/components/Charts/Timeline/TimelinePeriodSwitcher'
import TotalAmount from '@/views/Home/StoryMode/FinancialPlan/Components/TotalAmount'
import YearInfo from '@/views/Home/StoryMode/FinancialPlan/Components/YearInfo'

export default {
  name: 'RevenueOverTime',

  components: {
    ChartComponentRightSide,
    YearInfo,
    ChartComponent,
    RevenueOverTimeChart,
    TimelinePeriodSwitcher,
    TotalAmount
  },

  mixins: [MixinCalculations],

  props: {
    title: {
      type: String,
      default () {
        return this.$t('charts.revenueOverTime')
      }
    },
    chartAnimations: {
      type: Boolean,
      default: false
    },
    sharedIdea: {
      type: Object,
      default: null
    },
    hideRightSide: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 370
    }
  },

  data () {
    return {
      period: 'monthly',
      dateStringPeriodEndMonth: this.getDateStringPeriodEndMonth(),
      dateStringPlanningStartYear: this.getDateStringPlanningStartYear()
    }
  },

  computed: {
    totalAmount () {
      return this.$store.state.idea.storyMode.forecast.revenueStreams.timeline.total
    },

    byYearAmount () {
      return this.$store.state.idea.storyMode.forecast.revenueStreams.timeline.byYear
    }
  },

  methods: {
    switchChartPeriod (period) {
      this.$set(this, 'period', period)
    },

    getTotalExpensesEndOfYearDateString (year) {
      return `${this.$t('charts.endOf')} ${this.dateStringPeriodEndMonth} ${this.$moment(this.dateStringPlanningStartYear, 'YYYY').add(year + 1, 'Y').format('[\']YY')}`
    }
  }
}
</script>
